module.exports = __webpack_public_path__ + "img/电梯动画13.1a6061f6.png";